import React, { useState } from "react";
import { Modal, Typography, Icon } from "@ann/web-components";
import { ModalContentWrapper, ModalWrapper, ActionsContainer, ActionLabel } from "./FactsTrainingModal.styled";
import { TwoColumnContainer, Header, MessageContainer, TextInput } from "./components";

const FactsTrainingModal = ({ isOpen, onClose }) => {
  const [currentProgress, setCurrentProgress] = useState(0);
  const [inputValue, setInputValue] = useState("");

  const handleConfirm = () => {
    // TODO: Implement training confirmation logic
    console.log("Training confirmed");
    onClose();
  };

  const handleCancel = () => {
    onClose();
  };

  return (
    <ModalWrapper>
      <Modal
        isOpen={isOpen}
        onClose={handleCancel}
        size="medium"
        width="60%"
      >
        <Modal.Body>
          <ModalContentWrapper>

            <TwoColumnContainer
              leftContent={<Header currentProgress={currentProgress} />}
              rightContent={
                <MessageContainer
                  messages={[
                    {
                      type: "user",
                      content: "I believe the most important techniques include active listening, understanding customer pain points, and building rapport through empathy."
                    },
                    {
                      type: "system",
                      content: "One of the most important techniques is active listening. It helps uncover the real motivation behind a customer's request. Asking open-ended questions also helps understand their needs clearly."
                    },
                    {
                      type: "user",
                      content: "That makes sense. I've found that when I really listen to what customers are saying, I can identify their underlying concerns better. Sometimes they don't express their real needs directly."
                    },
                    {
                      type: "system",
                      content: "One of the most important techniques is active listening. It helps uncover the real motivation behind a customer's request. Asking open-ended questions also helps understand their needs clearly."
                    },
                    {
                      type: "user",
                      content: "I also think it's crucial to ask follow-up questions to dig deeper. For example, if a customer says they need a faster solution, I ask what specific problems the current speed is causing them."
                    },
                    {
                      type: "system",
                      content: "One of the most important techniques is active listening. It helps uncover the real motivation behind a customer's request. Asking open-ended questions also helps understand their needs clearly."
                    }
                  ]}
                />
              }
            />
          </ModalContentWrapper>
          <TextInput
            value={inputValue}
            onChange={setInputValue}
            placeholder="Type your instructions here..."
          />
          <ActionsContainer>
            <ActionLabel>
              <Icon name="arrowRight" size="small" />
              Skip Question
            </ActionLabel>
            <ActionLabel>
              <Icon name="folder" size="small" />
              Select From AIMS Drive
            </ActionLabel>
            <ActionLabel>
              <Icon name="group" size="small" />
              Ask for Team Member
            </ActionLabel>
          </ActionsContainer>
        </Modal.Body>
        <Modal.Actions align="end">
          <Modal.Button
            label="Cancel"
            onClick={handleCancel}
            type="secondary"
          />
          <Modal.Button
            label="Confirm"
            onClick={handleConfirm}
          />
        </Modal.Actions>
      </Modal>
    </ModalWrapper>
  );
};

export default FactsTrainingModal;
